import React, { FunctionComponent, ReactNode } from "react";
import Image from "next/image";
import styles from "@app/styles/shared/BasicPages.module.scss";

interface FormCompletedProps {
  /**
   * True when the learner is arriving at a form they already completed, rather than having just
   * submitted it. The form accepts one response, so there is nothing for them to do — saying
   * "Submitted Successfully" to someone who submitted last week reads as if it just happened.
   */
  alreadySubmitted?: boolean;
  /** Rendered under the message, e.g. a layout's auto-close note. */
  children?: ReactNode;
}

const FormCompleted: FunctionComponent<FormCompletedProps> = ({ alreadySubmitted = false, children }) => (
  <div className={styles.container}>
    <Image src="icons/formCompletedImage.svg" alt="" width={1000} height={400} />
    <h1>{alreadySubmitted ? "Already Submitted" : "Submitted Successfully!"}</h1>
    <p>{alreadySubmitted ? "You have already responded to this form. It accepts one response only." : "Thank you! Your response has been recorded."}</p>
    {children}
  </div>
);

export default FormCompleted;
